import { render, staticRenderFns } from "./ClauseManage.vue?vue&type=template&id=142372f6&scoped=true&"
import script from "./ClauseManage.vue?vue&type=script&lang=js&"
export * from "./ClauseManage.vue?vue&type=script&lang=js&"
import style0 from "./ClauseManage.vue?vue&type=style&index=0&id=142372f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142372f6",
  null
  
)

export default component.exports